import settings from './api.settings.json'

interface IfetchHeader {
    ['Content-Type']: string;
}

function errorHandler(error: object) {
    console.error(error);
}

const mainFetch = (target: string, config: RequestInit = {}, errorCallBack = errorHandler) => {
    config = {
        method: config.method || 'GET',
        mode: config.mode || 'cors',
        cache: config.cache || 'no-cache',
        credentials: config.credentials || 'same-origin',
        headers: {
            'Content-Type': 'application/json',
        },
        redirect: config.redirect || 'follow',
        referrerPolicy: config.referrerPolicy || 'no-referrer',
        body: config.body
    }
    return fetch(`${settings.baseURL}${target}`, config)
        .then(res => {
            if (res.status == 200) {
                return res.json();
            }
            errorCallBack(res)
            return false;
        })
        .then(
            (result) => {
                return result;
            },
            (error) => {
                errorCallBack(error)
                return false;
            })
}

const municipalityOrCompany = (errorCallBack = errorHandler) => {
    return mainFetch('municipalityOrCompany', {}, errorCallBack);
}

const insuranceChoice = (errorCallBack = errorHandler) => {
    return mainFetch('insuranceChoice', {}, errorCallBack);
}

const postNewSubmit = (data: any, errorCallBack = errorHandler) => {
    return mainFetch('submit', { method: "POST", body: JSON.stringify({ data: JSON.stringify(data) }) })
}

const validateAddress = (address: any, errorCallBack = errorHandler) => {
    return mainFetch('validateaddress', { method: "POST", body: JSON.stringify(address) })
}


export {
    municipalityOrCompany,
    insuranceChoice,
    postNewSubmit,
    validateAddress
}
